// extracted by mini-css-extract-plugin
export default {"search":"StudenSummaryt_search__h3oYr"};